/* handle sticky sidebar */
let sidebar = document.getElementsByClassName('blog-sidebar')[0];
let sidebar_content = document.getElementsByClassName('sidebar-inner')[0];
window.addEventListener('scroll', () => {
  if (window.innerWidth >= 750) {
    let scrollTop = window.scrollY; // current scroll position
    let viewportHeight = window.innerHeight; // viewport height
    let contentHeight = sidebar_content.getBoundingClientRect().height; // current content height
    let contentWidth = sidebar_content.getBoundingClientRect().width; // current content width
    let sidebarBottom = sidebar.getBoundingClientRect().bottom + window.scrollY;
    let sidebarTop = sidebar.getBoundingClientRect().top + window.scrollY; // distance from top to sidebar

    if (scrollTop >= contentHeight - viewportHeight + sidebarTop + 50) {
      sidebar_content.style.position = 'fixed';
      sidebar_content.style.width = `${contentWidth}px`;
      sidebar_content.style.transform = `translateY(-${contentHeight - viewportHeight + sidebarTop + 50}px)`;

      if (scrollTop + viewportHeight >= sidebarBottom) {
        let pressBar = document.getElementsByClassName('press-bar-section')[0];
        let pressBarTop = pressBar.getBoundingClientRect().top;
        sidebar_content.style.transform = `translateY(${pressBarTop - contentHeight - sidebarTop - 50}px)`;
      }
    } else {
      sidebar_content.style.transform = '';
      sidebar_content.style.position = '';
      sidebar_content.style.width = '';
    }
  }
});

/* handle sidebar drawer on mobile */
document.addEventListener('DOMContentLoaded', function () {
  const drawerOpen = document.querySelector('.blog-sidebar-trigger-btn');
  const blogSidebar = document.querySelector('.blog-sidebar');
  const overlay = document.querySelector('.overlay');
  const body = document.body;
  const drawerClose = document.querySelector('.blog-sidebar-close-btn');

  // Function to toggle the drawer and overlay
  function toggleDrawer() {
    blogSidebar.classList.toggle('open');
    overlay.classList.toggle('active');
    body.classList.toggle('overlay-active');
  }

  // Event listener for the toggle button
  drawerOpen.addEventListener('click', toggleDrawer);

  // Event listener for the overlay to close the drawer
  overlay.addEventListener('click', toggleDrawer);

  // Event listener for the close button in the drawer
  drawerClose.addEventListener('click', toggleDrawer);
});